<template>
    <v-tab-item v-if="superUser || permission" :value="$route.path">
        <v-row no-gutters class="pa-3 b-grey">
            <v-col
                cols="12"
                md="6"
                class="pr-3"
                v-if="
                    superUser ||
                    (permissions.settings.profile_attribute.logo &&
                        storePermissions.settings.profile_attribute.logo)
                "
            >
                <Logo />
            </v-col>
            <v-col
                cols="12"
                md="6"
                class="pl-3"
                v-if="
                    superUser ||
                    (permissions.settings.profile_attribute.pin_display &&
                        storePermissions.settings.profile_attribute.pin_display)
                "
            >
                <PinDisplay />
            </v-col>
            <v-col  v-if="
                    superUser ||
                    (permissions.settings.profile_attribute.pin_display_outside_operation_hours &&
                        storePermissions.settings.profile_attribute.pin_display_outside_operation_hours)
                " cols="12" md="6" class="pr-3 mt-6">
                <PinDisplayHours />
            </v-col>
            <v-col v-if="
                    superUser ||
                    (permissions.settings.profile_attribute.thermal_printer &&
                        storePermissions.settings.profile_attribute.thermal_printer)
                " cols="12" md="6" class="pr-3 mt-6">
                <ThermalPrinter />
            </v-col>
            <v-col
                cols="12"
                class="mt-6"
                v-if="
                    superUser ||
                    (permissions.settings.profile_attribute
                        .business_information &&
                        storePermissions.settings.profile_attribute
                            .business_information)
                "
            >
                <BusinessInformation />
            </v-col>
            <v-col
                cols="12"
                class="mt-6"
                v-if="
                    superUser ||
                    (permissions.settings.profile_attribute
                        .hours_of_operation &&
                        storePermissions.settings.profile_attribute
                            .hours_of_operation)
                "
            >
                <OperationHours />
            </v-col>
            <v-col
                cols="12"
                md="6"
                class="pr-3 mt-6"
                v-if="
                    superUser ||
                    (permissions.settings.profile_attribute.invoicing &&
                        storePermissions.settings.profile_attribute.invoicing)
                "
            >
                <Invoicing />
            </v-col>
            <v-col
                cols="12"
                md="6"
                class="pl-3 mt-6"
                v-if="
                    superUser ||
                    (permissions.settings.profile_attribute.fast_payment &&
                        storePermissions.settings.profile_attribute
                            .fast_payment)
                "
            >
                <FastPayment />
            </v-col>
            <v-col
                cols="12"
                md="6"
                class="pr-3 mt-6"
                v-if="
                    superUser ||
                    (permissions.settings.profile_attribute.shopping_cart &&
                        storePermissions.settings.profile_attribute
                            .shopping_cart)
                "
            >
                <ShoppingCart />
            </v-col>
            <v-col
                cols="12"
                md="6"
                class="pl-3 mt-6"
                v-if="
                    superUser ||
                    (permissions.settings.profile_attribute.change_password &&
                        storePermissions.settings.profile_attribute
                            .change_password)
                "
            >
                <ChangePassword />
            </v-col>
            <v-col
                cols="12"
                md="6"
                class="pr-3 mt-6"
                v-if="
                    superUser ||
                    (permissions.settings.profile_attribute
                        .redemption_settings &&
                        storePermissions.settings.profile_attribute
                            .redemption_settings)
                "
            >
                <RedemptionSettings />
            </v-col>
            <v-col
                cols="12"
                md="6"
                class="pr-3 mt-6"
                v-if="
                    superUser ||
                    (permissions.settings.profile_attribute
                        .coupon_claim_days &&
                        storePermissions.settings.profile_attribute
                            .coupon_claim_days)
                "
            >
                <StoreCouponClaimValidDays />
              
            </v-col>
                <v-col
                cols="12"
                md="6"
                class="pl-3 mt-6"
                v-if="
                    superUser ||
                    (permissions.settings.profile_attribute.cash_registers &&
                        storePermissions.settings.profile_attribute.cash_registers)
                " 
            >
                <CashRegisters />
            </v-col>
            
            <v-col
                cols="12"
                md="6"
                class="pl-3 mt-6"
                v-if="
                    superUser ||
                    (permissions.settings.profile_attribute.store_settings &&
                        storePermissions.settings.profile_attribute.store_settings)
                " 
            >
                <TransactionLimit />
            </v-col>
            <!-- <v-col cols="12" md="6" class="pl-3 mt-6">
                <ApiAuthentication />
            </v-col> -->
            <!-- <v-col cols="12" md="6" class="pr-3 mt-6" v-if="superUser || permissions.settings.profile_attribute.delivery_settings && storePermissions.settings.profile_attribute.delivery_settings">
                <DeliverySettings />
            </v-col> -->
        </v-row>
    </v-tab-item>
</template>

<script>
import profile from "@/store/modules/storePanel/settings/profile";

import { mapActions, mapState, mapMutations } from "vuex";

import Logo from "@/components/storePanel/settings/profile/Logo";
import PinDisplay from "@/components/storePanel/settings/profile/PinDisplay";
import PinDisplayHours from "@/components/storePanel/settings/profile/PinDisplayHours";
import BusinessInformation from "@/components/storePanel/settings/profile/BusinessInformation";
import OperationHours from "@/components/storePanel/settings/profile/OperationHours";
import Invoicing from "@/components/storePanel/settings/profile/Invoicing";
import FastPayment from "@/components/storePanel/settings/profile/FastPayment";
import ShoppingCart from "@/components/storePanel/settings/profile/ShoppingCart";
import ThermalPrinter from "@/components/storePanel/settings/profile/ThermalPrinter";
import ChangePassword from "@/components/storePanel/settings/profile/ChangePassword";
import RedemptionSettings from "@/components/storePanel/settings/profile/RedemptionSettings";
import StoreCouponClaimValidDays from "@/components/storePanel/settings/profile/StoreCouponClaimValidDays";
// import ApiAuthentication from "@/components/storePanel/settings/profile/ApiAuthentication";
import DeliverySettings from "@/components/storePanel/settings/profile/DeliverySettings";
// import CashRegisters from "../../../../components/storePanel/settings/profile/CashRegisters.vue";
import CashRegisters from "@/components/storePanel/settings/profile/CashRegisters";
import TransactionLimit from "@/components/storePanel/settings/profile/TransactionLimit";

export default {
    name: "Profile",

    components: {
    Logo,
    PinDisplay,
    PinDisplayHours,
    BusinessInformation,
    OperationHours,
    Invoicing,
    FastPayment,
    ShoppingCart,
    ChangePassword,
    RedemptionSettings,
    StoreCouponClaimValidDays,
    ThermalPrinter,
    CashRegisters,
    TransactionLimit
},

    computed: {
        ...mapState(["permissions", "storePermissions", "superUser"]),
        lang() {
            return this.$route.params.lang;
        },

        permission() {
            return this.$store.state.permissions.settings
                ? this.$store.state.permissions.settings.profile_attribute
                : this.superUser;
        },
    },

    methods: {
        ...mapActions("storePanel", ["getStore"]),
        ...mapMutations(["setNotification"]),

    },

    watch: {
        permission: {
            immediate: true,
            handler(val) {
                if (!val && !this.superUser) {
                    this.$router.replace(
                        `/${this.lang}/storePanel/forbidden-gateway`
                    );
                }
            },
        },
        ["$store.state.storePanel.profile.errorMessage"]: {
            immediate: true,
            handler(val, oldVal) {
                if(val&&oldVal){
                    for (let key in val) {
                        if(val[key]){
                            //show notification
                            this.setNotification({
                                show: true,
                                type: "error",
                                text: val[key]
                            });
                        }
                    }
                }
            },
            deep: true,
        },
    },

    beforeCreate() {
        if (!this.$store.state.storePanel.profile) {
            this.$store.registerModule(["storePanel", "profile"], profile);
        }
    },

    mounted() {
        this.getStore();
        this.$clearFocus();
    },
};
</script>
